import { SUMFS_HOST, getEnvName } from '@/config';
import request from '@/service/apiConfig/request';

const originUrl = SUMFS_HOST[getEnvName()];
/**
 * @description PC选品库分组列表
 */
export const saveCommodity = params => {
	return request.jsonp(originUrl + '/sumis-web/robotSelection/saveCommodity.json', params);
};
